import { Connection } from '@/types/connections';

// Use Lucy's internal user ID (not auth_id)
const LUCY_ID = 'a125a4ca-5ff3-45d6-b8b7-cfe3c015c600';

/**
 * Get the set of user IDs connected to a specific user, excluding Lucy.
 */
export function getConnectedUserIds(userId: string, connections: Connection[]): Set<string> {
  return new Set(
    connections
      .filter(
        (conn) =>
          conn.status === 'accepted' &&
          (conn.initiator_id === userId || conn.receiver_id === userId)
      )
      .map((conn) => (conn.initiator_id === userId ? conn.receiver_id : conn.initiator_id))
      .filter((id) => id !== LUCY_ID)
  );
}

/**
 * Calculate how many mutual connections exist between two users, excluding Lucy.
 */
export function countMutualConnections(
  userId1: string,
  userId2: string,
  connections: Connection[]
): number {
  const set1 = getConnectedUserIds(userId1, connections);
  const set2 = getConnectedUserIds(userId2, connections);

  let mutualCount = 0;
  for (const id of set1) {
    if (set2.has(id)) {
      mutualCount++;
    }
  }

  return mutualCount;
}
